var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.8 17.4c0-0.8 0.2-1.6 0.6-2 0.4-0.4 1-0.6 1.6-0.6 0.6 0 1.2 0.2 1.6 0.6 0.4 0.4 0.6 1 0.6 2 0 0.8-0.2 1.6-0.6 2-0.4 0.4-0.8 0.6-1.6 0.6-0.6 0-1.2-0.2-1.6-0.6-0.4-0.4-0.6-1-0.6-2z m4.2 32.4h-3.8v-25.4h3.8v25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeMiterlimit: 10,
    d: "M21.26 6.14a28 28 0 1 0 21.54 51.68 28 28 0 1 0-21.54-51.68z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.9b6efb29fcfd2710d002eba7c4f6848a.svg";
export { ForwardRef as ReactComponent };